// Enums
export enum AssetType {
  CLOUD = 'CLOUD',
  SAAS = 'SAAS',
  API = 'API',
  AI = 'AI',
  SOFTWARE = 'SOFTWARE',
}

export enum ComplianceFramework {
  GDPR = 'GDPR',
  NIS2 = 'NIS2',
  DORA = 'DORA',
  EPRIVACY = 'EPRIVACY',
  AI_ACT = 'AI_ACT',
  ISO27001 = 'ISO27001',
  SOC2 = 'SOC2',
  HIPAA = 'HIPAA',
  PCI_DSS = 'PCI_DSS',
}

export enum Jurisdiction {
  EU = 'EU',
  US = 'US',
  UK = 'UK',
  CHINA = 'CHINA',
  INDIA = 'INDIA',
  HONG_KONG = 'HONG_KONG',
  RUSSIA = 'RUSSIA',
  SWITZERLAND = 'SWITZERLAND',
  BRAZIL = 'BRAZIL',
  SINGAPORE = 'SINGAPORE',
  AUSTRALIA = 'AUSTRALIA',
  CANADA = 'CANADA',
  JAPAN = 'JAPAN',
  OTHER = 'OTHER',
}

export enum Criticality {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export enum RiskLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

// Domain types
export interface Organization {
  id: string;
  name: string;
  sector: string;
  country: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Project {
  id: string;
  organizationId: string;
  name: string;
  description: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface Asset {
  id: string;
  projectId: string;
  name: string;
  type: AssetType;
  provider: string;
  jurisdiction: Jurisdiction;
  criticality: Criticality;
  createdAt: Date;
  updatedAt: Date;
}

export interface RiskAssessment {
  id: string;
  assetId: string;
  gdprRisk: RiskLevel;
  nis2Risk: RiskLevel;
  doraRisk: RiskLevel;
  overallRiskScore: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface ScanReport {
  id: string;
  projectId: string;
  sovereigntyScore: number;
  totalAssets: number;
  nonEUAssets: number;
  highRiskAssets: number;
  generatedAt: Date;
}

// API Response types
export interface DashboardStats {
  totalAssets: number;
  nonEUAssets: number;
  highRiskAssets: number;
  sovereigntyScore: number;
  euVsNonEU: {
    eu: number;
    nonEU: number;
  };
  riskDistribution: {
    low: number;
    medium: number;
    high: number;
  };
}
